import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { Component, Fragment } from "react"
import { Redirect } from "react-router-dom"
import moment from "moment"
import { Tooltip, Modal } from "reactstrap"

import MKIDatatable from "../../../../../modules/mki-datatable/lib"

import { cancelToken } from "../../../../../services/adapters/base"

import DataTableBloc from "../Blocs/DataTableBloc"
import apiResponse from "../../../../../services/apiResponse"
import { ConfirmAlert } from "../../../../../helpers/ui/alert"

import HistoryComponent from "./HistoryComponent"

class TableActiveComponent extends Component {
    dataTableBloc = new DataTableBloc()

    source
    historyTable = "historySettingCronActive"
    defaultOrder = "job_run"
    defaultSize = 10
    defaultSort = "desc"
    configDatatable = {
        ...config("datatable"),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort,
        },
    }

    constructor(props) {
        super(props)
        this.state = {
            showHistory: false,
            jobUuid: null,
            tooltip: false,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable)
                ? JSON.parse(sessionStorage.getItem(this.historyTable))
                : {
                      filter_value: "",
                      page_number: 1,
                      page_size: this.defaultSize,
                      sort_order: {
                          column: this.defaultOrder,
                          order: this.defaultSort,
                      },
                  },
        }
    }
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip })

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(
            this.historyTable,
            JSON.stringify(this.state.filter)
        )

        /* kirim ke server */
        let offset =
            (this.state.filter.page_number - 1) * this.state.filter.page_size
        if (this.state.defaultSize !== this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size,
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
        }
        await this.dataTableBloc.fetchRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel()
        }
        this.source = cancelToken()
        this.loadData()
    }

    componentDidMount() {
        this.setTokenAPI()

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false,
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true,
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false,
                    })
                    break
                case apiResponse.ERROR:
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.inactiveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState(
                        {
                            loading: false,
                            success: true,
                            loadingTable: true,
                        },
                        function () {
                            this.setTokenAPI()
                            this.props.handleInactiveSuccess()
                        }
                    )
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    })
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.forceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState(
                        {
                            forceLoading: false,
                            forceSuccess: true,
                            loadingTable: true,
                        },
                        function () {
                            this.setTokenAPI()
                        }
                    )
                    break
                case apiResponse.ERROR:
                    this.setState({
                        forceLoading: false,
                        forceFailed: true,
                    })
                    break
                default:
                    break
            }
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case "cancel":
                forState = {
                    confirm: false,
                }
                break
            case "confirm":
                forState = {
                    loading: true,
                    confirm: false,
                }
                this.inactiveData()
                break
            case "success":
                forState = {
                    success: false,
                }
                break
            case "failed":
                forState = {
                    failed: false,
                }
                break
            default:
        }
        this.setState(forState)
    }

    inactiveData = async () => {
        await this.dataTableBloc.fetchInactive({ uuid: this.state.jobUuid })
    }

    forceResponse = (response) => {
        let forState = {}
        switch (response) {
            case "cancel":
                forState = {
                    forceConfirm: false,
                }
                break
            case "confirm":
                forState = {
                    forceLoading: true,
                    forceConfirm: false,
                }
                this.forceData()
                break
            case "success":
                forState = {
                    forceSuccess: false,
                }
                break
            case "failed":
                forState = {
                    failed: false,
                }
                break
            default:
        }
        this.setState(forState)
    }

    forceData = async () => {
        await this.dataTableBloc.fetchForce({ uuid: this.state.jobUuid })
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel.unsubscribe()
        this.dataTableBloc.inactiveChannel.unsubscribe()
        this.dataTableBloc.forceChannel.unsubscribe()
    }

    columns = [
        {
            key: "job_schedule",
            text: "Ekspresi",
            align: "center",
            sortable: true,
            width: "180",
        },
        {
            key: "job_name",
            text: "Nama Jadwal",
            sortable: true,
        },
        {
            key: "job_query",
            text: "Query",
            sortable: true,
        },
        {
            key: "job_run",
            text: "Status",
            sortable: true,
            align: "center",
            width: "160",
            cell: (record) => {
                var className =
                    (record.job_run > 0 ? "bg-success" : "bg-secondary") +
                    " rounded-circle d-inline-block"
                return (
                    <>
                        <div
                            className={className}
                            style={{ height: 10, width: 10 }}
                        ></div>
                    </>
                )
            },
        },
        {
            key: "job_nextrun",
            text: "Berikutnya",
            sortable: true,
            width: "340",
            cell: (record) => (
                <span>{moment(record.job_nextrun).format("dddd, LLL")}</span>
            ),
        },
        {
            key: "action",
            text: "Action",
            width: 120,
            sortable: false,
            align: "center",
            cell: (record) => {
                const thisId = record.job_uuid
                return (
                    <Fragment>
                        {accessRole("update") &&
                        record.job_run === 0 &&
                        moment(record.job_nextrun).isAfter(moment()) ? (
                            <span>
                                <button
                                    className="btn btn-success btn-sm"
                                    id={"active-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            jobUuid: record.job_uuid,
                                            forceConfirm: true,
                                        })
                                    }}
                                    style={{
                                        marginRight: "2px",
                                        padding: "2px 5px",
                                    }}
                                >
                                    <i className="uil-play"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2,
                                    }}
                                    placement="top"
                                    isOpen={this.state["active" + thisId]}
                                    target={"active-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["active" + thisId]:
                                                !this.state["active" + thisId],
                                        })
                                    }}
                                >
                                    Aktifkan
                                </Tooltip>
                            </span>
                        ) : (
                            <button
                                className="btn btn-soft-success btn-sm"
                                disabled={true}
                                style={{
                                    marginRight: "2px",
                                    padding: "2px 5px",
                                }}
                            >
                                <i className="uil-play"></i>
                            </button>
                        )}
                        <span>
                            <button
                                className="btn btn-warning btn-sm"
                                id={"history-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        jobUuid: record.job_uuid,
                                        showHistory: true,
                                    })
                                }}
                                style={{
                                    marginRight: "2px",
                                    padding: "2px 5px",
                                }}
                            >
                                <i className="uil-clock-eight"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2,
                                }}
                                placement="top"
                                isOpen={this.state["history" + thisId]}
                                target={"history-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["history" + thisId]:
                                            !this.state["history" + thisId],
                                    })
                                }}
                            >
                                Riwayat
                            </Tooltip>
                        </span>
                        {accessRole("delete") ? (
                            <span>
                                <button
                                    className="btn btn-danger btn-sm"
                                    id={"delete-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            jobUuid: record.job_uuid,
                                            confirm: true,
                                        })
                                    }}
                                    style={{
                                        padding: "2px 5px",
                                    }}
                                >
                                    <i className="uil-trash-alt"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2,
                                    }}
                                    placement="top"
                                    isOpen={this.state["delete" + thisId]}
                                    target={"delete-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["delete" + thisId]:
                                                !this.state["delete" + thisId],
                                        })
                                    }}
                                >
                                    Nonaktifkan
                                </Tooltip>
                            </span>
                        ) : (
                            <button
                                className="btn btn-soft-secondary btn-sm"
                                disabled={true}
                                style={{
                                    padding: "2px 5px",
                                }}
                            >
                                <i className="uil-trash-alt"></i>
                            </button>
                        )}
                    </Fragment>
                )
            },
        },
    ]
    render() {
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState(
                            {
                                loadingTable: true,
                                filter: filter,
                            },
                            function () {
                                this.setTokenAPI()
                            }
                        )
                    }}
                    loading={this.state.loadingTable}
                />

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menghapus data ini?"
                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"
                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"
                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"
                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}
                    response={this.confirmResponse}
                />

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menjalankan data ini?"
                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"
                    successTitle="Berhasil!"
                    successInfo="Data berhasil dijalankan"
                    failedTitle="Gagal!"
                    failedInfo="Data gagal dijalankan"
                    showConfirm={this.state.forceConfirm}
                    showLoading={this.state.forceLoading}
                    showSuccess={this.state.forceSuccess}
                    showFailed={this.state.forceFailed}
                    response={this.forceResponse}
                />

                <Modal
                    size="lg"
                    isOpen={this.state.showHistory}
                    toggle={() => {
                        this.setState({
                            showHistory: !this.state.showHistory,
                        })
                    }}
                >
                    <div className="modal-header">
                        <h5
                            className="modal-title mt-0"
                            id="myLargeModalLabelx"
                        >
                            History
                        </h5>
                        <button
                            onClick={() => {
                                this.setState({
                                    showHistory: false,
                                })
                            }}
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <HistoryComponent uuid={this.state.jobUuid} />
                    </div>
                </Modal>
            </>
        )
    }
}

export default TableActiveComponent
